import script from "./HeaderCom.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderCom.vue?vue&type=script&setup=true&lang=js"

import "./HeaderCom.vue?vue&type=style&index=0&id=09d12952&lang=scss"

const __exports__ = script;

export default __exports__